import { AppBar, Button, FormControlLabel, IconButton, Switch, Toolbar, Typography, Menu, MenuItem } from '@material-ui/core'
import { Menu as MenuIcon } from '@material-ui/icons'
import React, { useState } from 'react'
import { getTitle } from '../utils'
import { MANAGE_USERS, OFFICE_USER } from '../constants/permissions.json'

const onHomeClick = () => {
  if (History.location.pathname !== '/') History.push('/')
}

const onUsersClick = () => {
  if (History.location.pathname !== '/users') History.push('/users')
}

const onMapClick = () => {
  if (History.location.pathname !== '/map') History.push('/map')
}

const onLoginsClick = () => {
  if (History.location.pathname !== '/logins') History.push('/logins')
}

const onHelpClick = () => {
  if (History.location.pathname !== '/help') History.push('/help')
}

const onLogoutClick = (logout) => {
  return () => {
    logout()
  }
}

export default ({ user, logout, endImpersonation, printPdf, setOverrideUrl, additionalBtns }) => {
  const { isImpersonating, username } = user
  const isAdmin = username.toLowerCase() === 'admin'
  const [anchorEl, setAnchorEl] = useState();

  function menuClick(e) {
    setAnchorEl(e.currentTarget);
  }

  function onClose() {
    setAnchorEl(null);
  }

  return (
    <AppBar>
      <Toolbar>
        <div>
          <IconButton edge="start" color="inherit" aria-label="Menu" onClick={menuClick}>
            <MenuIcon />
          </IconButton>
          <Menu {...{
            id: 'homemenu',
            anchorEl,
            keepMounted: true,
            open: !!anchorEl,
            onClose
          }}>
            <MenuItem>
              <a onClick={onClose} href='/timetracker' target='_blank' rel='noreferrer' style={{ textDecoration: 'none', color: 'black' }}>
                Time Tracker
              </a>
            </MenuItem>
            {user.permissions.includes(OFFICE_USER) && (
              <MenuItem>
                <a onClick={onClose} href='/timetrackeradmin' target='_blank' rel='noreferrer' style={{ textDecoration: 'none', color: 'black' }}>
                  Time Tracker Admin
                </a>
              </MenuItem>
            )}
          </Menu>
        </div>
        <Typography variant="h6" color="inherit">{getTitle()}</Typography>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button style={{ marginLeft: 20 }} onClick={onHomeClick} color="inherit">Home</Button>
            <Button style={{ marginLeft: 20 }} onClick={onUsersClick} color="inherit">{user.permissions.includes(MANAGE_USERS) ? 'Users' : 'Profile'}</Button>
            {user.permissions.includes(OFFICE_USER) && <Button style={{ marginLeft: 20 }} onClick={onMapClick} color="inherit">Map</Button>}
            {isAdmin && <Button style={{ marginLeft: 20 }} onClick={onLoginsClick} color="inherit">Logins</Button>}
            <Button style={{ marginLeft: 20 }} onClick={onHelpClick} color="inherit">Help</Button>
            {/* {printPdf && <Button style={{ marginLeft: 20 }} onClick={printPdf} color="inherit">Print</Button>} */}
            {(printPdf && user.username.toLowerCase() === 'admin') ? <Button style={{ marginLeft: 20 }} onClick={printPdf} color="inherit">Print</Button> : null}
          </div>
          {/* {user.permissions.includes(OFFICE_USER) && additionalBtns} */}
          {user.username.toLowerCase() === 'admin' && additionalBtns}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', gap: 10 }}>
            {isAdmin && (
              <FormControlLabel
                control={(
                  <Switch
                    checked={!user.overrideUrl}
                    color={user.overrideUrl ? 'secondary' : 'default'}
                    onChange={e => {
                      setOverrideUrl(!user.overrideUrl)
                    }}
                  />
                )}
                label={user.overrideUrl ? 'Test' : 'Live'}
              />
            )}
            {isImpersonating && <div>Impersonating {username}</div>}
            {isImpersonating ?
              <Button onClick={() => endImpersonation()} color="inherit">End Impersonation</Button> :
              <Button onClick={onLogoutClick(logout)} color="inherit">Logout</Button>
            }
          </div>
        </div>
      </Toolbar>
    </AppBar>
  )
}
